// extracted by css-extract-rspack-plugin
export default {"page":"HowItWorksV2-module__page"};